module.exports = __webpack_public_path__ + "img/1.f61894c6.png";